module.exports = __webpack_public_path__ + "img/TEMPLATE_Leap Learning report - hotspots.2b39786a.png";